function hideAlert(){
  $('.vat-popup').hide();
  $('.vat-modal').hide();
  // document.querySelector('[data-id="including-vat"]').click();
  const el = document.querySelector('[data-id="including-vat"] input');
  el.checked = true;
  el.dispatchEvent(new Event('change', { bubbles: true }));
  $('#addToCartBtn').trigger('click');
};
function toggleBtn() {
  document.getElementById("submitBtn").disabled =
    !document.getElementById("agree_vateeee").checked;
}

function showAlert() {    
  var VatReliefDeclaration = localStorage.getItem("VatReliefDeclaration");
   console.log('VatReliefDeclaration: ',VatReliefDeclaration);
    if (VatReliefDeclaration) {
      var initialVAT = $('.option-vat:checked').val();
      console.log('initialVAT: ',initialVAT);
      if(initialVAT === 'Including VAT'){
        $('.vat-error').show();
        $('.vat-modal').show();
        event.target.classList.add('clicked');
      }else{
        $('#addToCartBtn').trigger('click');
      }
      return false;
  }else{
    $('.vat-declaration-form-choice').show();
    $('.vat-modal').show();
  }
}
$(document).ready(function () {
 
const block = document.querySelector('.vat-content-price.uk');
const button = document.querySelector('#addToCartBtn');
const recommendation = document.querySelector('.recommendation-page-layout');

// safe check (jo block null hoy to error na ave)
const divCount = block ? block.querySelectorAll('div').length : 0;

console.log('divcount', divCount);

if (block || recommendation) {
  if (divCount > 0 || recommendation) {
    $('.product-cart_button').append(
      '<a href="#" onclick="return showAlert()" class="btn btn-1" id="myAddToCart">Add to cart</a>'
    );

    $('.fbt-product-cart_button').append(
      '<a href="#" onclick="return showAlert()" class="btn btn-1" id="myAddToCart">Add all to cart</a>'
    );
  } else {
    button.style.display = "block";
  }
} else {
  button.style.display = "block";
}

// Function to force "Including VAT" selection for non-UK markets
function forceIncludingVATSelection() {
  if (!window.isUKMarket) {
    // Find the Including VAT variant from the main product selector
    const mainVariantSelect = document.querySelector('select[name="id"]');
    let includingVatVariant = null;
    
    if (mainVariantSelect) {
      // Check if current selection is VAT Exempt
      const currentVariant = mainVariantSelect.options[mainVariantSelect.selectedIndex];
      if (currentVariant && currentVariant.textContent.includes('VAT Exempt')) {
        // Look for Including VAT variant in the main selector
        includingVatVariant = Array.from(mainVariantSelect.options).find(option => 
          option.textContent.includes('Including VAT')
        );
        
        if (includingVatVariant) {
          mainVariantSelect.value = includingVatVariant.value;
          
          // Update hidden variant input
          const variantInput = document.querySelector('input[name="id"]');
          if (variantInput) {
            variantInput.value = includingVatVariant.value;
          }
          
          // Trigger change event on the main selector
          mainVariantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
    
    // Update VAT radio buttons
    const vatRadios = document.querySelectorAll('input[name="VAT"], input[name="FBT VAT"]');
    vatRadios.forEach(radio => {
      if (radio.value === 'Including VAT') {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    
    // Update VAT select dropdowns
    const vatSelects = document.querySelectorAll('select[name="options[VAT]"]');
    if (vatSelects.length > 0) {
      // Batch process all selects at once instead of individual processing
      const includingVatOption = Array.from(vatSelects[0].options).find(option => 
        option.value === 'Including VAT'
      );
      if (includingVatOption) {
        vatSelects.forEach(select => {
          select.value = 'Including VAT';
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
    }
    
    // Update FBT VAT inputs
    const fbtVatInputs = document.querySelectorAll('.fbt_vat_change-js[value="Including VAT"]');
    fbtVatInputs.forEach(input => {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    
    return true; // Return true if successful
  } else {
    return false; // Return false if not UK market or not successful
  }
}

// Function to handle URL variant parameters for non-UK markets
function handleURLVariantOverride() {
  if (!window.isUKMarket && window.location.search.includes('variant=')) {
    // Extract variant ID from URL
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
    
    if (variantId) {
      // Check if this variant is VAT Exempt
      const mainVariantSelect = document.querySelector('select[name="id"]');
      if (mainVariantSelect) {
        const currentVariant = Array.from(mainVariantSelect.options).find(option => 
          option.value === variantId
        );
        
        if (currentVariant && currentVariant.textContent.includes('VAT Exempt')) {
          const result = forceIncludingVATSelection();
          return result; // Return immediately if successful
        }
      } else {
        // If mainVariantSelect is not available yet, try again after a shorter delay
        setTimeout(() => {
          handleURLVariantOverride();
        }, 200); // Reduced from 500ms to 200ms
      }
    }
  }
  
  return false;
}

// Optimized function to handle all non-UK market VAT logic
function handleNonUKMarketVAT() {
  // Check if non-UK VAT override has already been completed
  if (window.nonUKVATOverrideCompleted) {
    return;
  }
  
  if (!window.isUKMarket) {
    // Try immediate URL override first
    if (handleURLVariantOverride()) {
      window.nonUKVATOverrideCompleted = true; // Mark as completed for non-UK markets only
      return; // If URL override was successful, we're done
    }
    
    // If no URL override needed, still ensure correct VAT selection
    const result = forceIncludingVATSelection();
    if (result) {
      window.nonUKVATOverrideCompleted = true; // Mark as completed for non-UK markets only
    }
  }
}

// Immediate URL variant override check for non-UK markets
handleNonUKMarketVAT();

// Additional immediate check when DOM is ready
$(document).ready(function() {
  // Handle FBT VAT initialization
  handleFBTVATInitialization();
  
  // Handle Product Bundle VAT initialization
  handleProductBundleVATInitialization();
  
  // Quick check for non-UK markets with URL variants
  if (!window.isUKMarket && window.location.search.includes('variant=') && !window.nonUKVATOverrideCompleted) {
    setTimeout(() => {
      handleNonUKMarketVAT();
      // Also handle FBT VAT after main VAT check
      handleFBTVATInitialization();
      // Also handle Product Bundle VAT after main VAT check
      handleProductBundleVATInitialization();
    }, 50); // Very short delay to ensure DOM is ready
  }
});

//     var VatReliefDeclaration = localStorage.getItem("VatReliefDeclaration");
//   if (VatReliefDeclaration) {
//     // Remove auto-selection logic - let the default variant selection behavior work
//     // VAT selectors will remain visible for UK markets but won't auto-select
//     var updateValues = JSON.parse(VatReliefDeclaration);
//     $('#first_name_vat').val(updateValues["First Name"]);
//     $('#last_name_vat').val(updateValues["Last Name"]);
//     $('#email_vat').val(updateValues["Email"]);
//     $('#otherDisease_vat').val(updateValues["Other Disease"]);
//     $('#disease_vat').val(updateValues["Condition"]);
//     $('#agree_vat').prop('checked', true);
//     //alert('sdasdasd');
//     fetch('/cart/update.js', {
//         method: "POST",
//         headers: {
//             'X-Requested-With': 'XMLHttpRequest',
//             'Content-Type': 'application/json'
//         },
//         body: JSON.stringify({
//             attributes: {
//                 'First Name': updateValues["First Name"],
//                 'Last Name': updateValues["Last Name"],
//                 'Email': updateValues["Email"],
//                 'Condition': updateValues["Condition"],
//                 'Other Disease': updateValues["Other Disease"],
//                 'Agree VAT': updateValues["Agree"]
//             }
//         })
//     })
//     .then(res => res.json())
//     .then(data => console.log("Cart updated:", data))
//     .catch(err => console.error("Error:", err));
//     $('.vat-msg').addClass('hide');
//     $('.success-msg').removeClass('hide');
// } else {
//     // Remove auto-selection logic - let the default variant selection behavior work
//     // VAT selectors will remain visible for UK markets but won't auto-select
    
//     var option_vat = $('.option-vat:checked').val();
//     if (option_vat === 'VAT Exempt') {
//         setTimeout(function() {
//             $('.pdp-button-main').addClass("disabled");
//         }, 2000);
//     }
//     $('.vat-msg').removeClass('hide');
//     fetch('/cart/update.js', {
//         method: "POST",
//         headers: {
//             'X-Requested-With': 'XMLHttpRequest',
//             'Content-Type': 'application/json;'
//         },
//         body: JSON.stringify({
//             attributes:''
//         })
//     });
// }


$(document).ready(function () {

  // =========================
  // CUSTOM DROPDOWN
  // =========================

  // Open / Close
   // Open / Close
  let isTouched = false;
  $(document).on('touchstart', '.dropdown-selected', function (e) {
      e.stopPropagation();
      e.preventDefault();
      isTouched = true;
      $('#disease_dropdown').toggleClass('active');
  });
  $(document).on('click', '.dropdown-selected', function (e) {
      if (isTouched) {
          isTouched = false;
          return;
      }
      e.stopPropagation();
      e.preventDefault();
      $('#disease_dropdown').toggleClass('active');
  });

  // Select option
  $(document).on('click', '.dropdown-options div', function () {
    var value = $(this).data('value');

    $('.dropdown-selected').text(value);
    $('#disease_vat').val(value);

    $('#disease_dropdown').removeClass('active');
  });

  // Close on outside click
  $(document).on('click touchstart', function (e) {
    if ($(e.target).closest('#disease_dropdown').length) {
        return;
    }
      $('#disease_dropdown').removeClass('active');
  });



  // =========================
  // YOUR EXISTING CODE + FIX
  // =========================

  var VatReliefDeclaration = localStorage.getItem("VatReliefDeclaration");

  if (VatReliefDeclaration) {

    var updateValues = JSON.parse(VatReliefDeclaration);

    $('#first_name_vat').val(updateValues["First Name"]);
    $('#last_name_vat').val(updateValues["Last Name"]);
    $('#email_vat').val(updateValues["Email"]);
    $('#otherDisease_vat').val(updateValues["Other Disease"]);

    // ✅ IMPORTANT FIX (custom dropdown UI set)
    $('#disease_vat').val(updateValues["Condition"]);
    $('.dropdown-selected').text(updateValues["Condition"]);

    $('#agree_vat').prop('checked', true);

    fetch('/cart/update.js', {
      method: "POST",
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          'First Name': updateValues["First Name"],
          'Last Name': updateValues["Last Name"],
          'Email': updateValues["Email"],
          'Condition': updateValues["Condition"],
          'Other Disease': updateValues["Other Disease"],
          'Agree VAT': updateValues["Agree"]
        }
      })
    })
    .then(res => res.json())
    .then(data => console.log("Cart updated:", data))
    .catch(err => console.error("Error:", err));

    $('.vat-msg').addClass('hide');
    $('.success-msg').removeClass('hide');

  } else {

    var option_vat = $('.option-vat:checked').val();

    if (option_vat === 'VAT Exempt') {
      setTimeout(function () {
        $('.pdp-button-main').addClass("disabled");
      }, 2000);
    }

    $('.vat-msg').removeClass('hide');

    fetch('/cart/update.js', {
      method: "POST",
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json;'
      },
      body: JSON.stringify({
        attributes: ''
      })
    });
  }

});
  var option_size =$('.vat-content-price').data('option-size') * 1;
  if (option_size > 1) {
     var varient_Value = $('[name="id"] option:selected').text();
     const varient_array = varient_Value.split("/ ");
      var variant_one = varient_array[0].trim();
      var variant_two = varient_array[1].trim();
      var variant_three = varient_array[2];

    var selected_variant_val = $('.select-option select option:selected').val();
      console.log(selected_variant_val);
    let newvalue ='';
    $('[name="options[VAT]"] option').each(function () {
        var selected_VAT_Value= $(this).val();
      if(variant_three != undefined){
       var variant_lastest =  variant_three.trim();
         newvalue = selected_VAT_Value+' / '+variant_two+' / '+variant_lastest;
      }else{
          newvalue =variant_one+' / '+selected_VAT_Value;
      }
        $(".bold-price").each(function () {
          if ($(this).data("option").includes(newvalue)) {
            $(this).show();
          }
      });
    });
  } else {
    $(".bold-price").show();
  }

  $('.vat_change-js').on("change", function () {    
    var selectedValue = $(this).val();
    $(`.fbt_vat_change-js[value="${selectedValue}"]`).trigger('click');
    
    // Check if we're in a non-UK market and force "Including VAT" if needed
    if (!window.isUKMarket && selectedValue === 'VAT Exempt') {
      $('.vat_change-js[value="Including VAT"]').prop('checked', true).trigger('change');
      return;
    }
    
if(selectedValue === 'Including VAT'){
  var current_screen_size = $(window).width();
  if(current_screen_size >= 768) {
    setTimeout(function() {
      $('#tab_fbt_radio_including-vat').trigger('click');
    }, 200);
  }else{
    setTimeout(function() {
    $('[for="mob_tab_fbt_radio_including-vat"]').trigger('click');
    }, 200);
  } 
}else{
  var current_screen_size = $(window).width();
  if(current_screen_size >= 768) {
    setTimeout(function() {
      $('#tab_fbt_radio_vat-exempt').trigger('click');
    }, 200);
  }else{
    setTimeout(function() {
     $('[for="mob_tab_fbt_radio_vat-exempt"]').trigger('click');
    }, 200);
  }
}
   



    $('[name="options[VAT]"]').val(selectedValue);
    var changeEvent = new Event('change');
 $('.variants-wrapper [name="options[VAT]"]')[0].dispatchEvent(changeEvent);
    var VatReliefDeclaration = localStorage.getItem("VatReliefDeclaration");
    if(selectedValue ==='VAT Exempt'){
      $('.basket-vat-declare').show();

        if(!VatReliefDeclaration){
           $('.pdp-button-main').addClass("disabled");
        }else{
        $('.pdp-button-main').removeClass("disabled");
        }
    }else{
        if(VatReliefDeclaration){
           $('.pdp-button-main').addClass("disabled");
        }else{
        $('.pdp-button-main').removeClass("disabled");
        }

      $('.basket-vat-declare').hide();
    }

  });






$(document).on('click', '.vat-modal-trigger, .changeVatDetails, .card_price', function(event) {
    event.preventDefault();
    $('.vat-declaration-form').show();
    $('.vat-modal').show();
});

$(document).on('click', '.vat-popup .close, .popup-btn-no', function() {
    $('.vat-popup').hide();
    $('.vat-modal').hide();
    $('.pdp-button-main a').removeClass('clicked');
});

$(document).on('click', '.vat-modal', function() {
    $('.vat-popup').hide();
    $('.vat-modal').hide();
});

$(document).on('click', '.popup-btn-yes', function() {
    $('.vat-popup').hide();
    $('.vat-modal').hide();
    $('.pdp-button-main a.clicked').siblings('button').trigger('click');
    $('.pdp-button-main a').removeClass('clicked');
});

async function replaceCartItemsWithVatExempt() {
  try {
    // Получаем текущую корзину
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();
    
    if (!cart.items || cart.items.length === 0) {
      return; // Корзина пустая
    }
    
    // Собираем все карточки товаров на странице с информацией о вариантах
    const variantMap = new Map();
    document.querySelectorAll('[data-variant-with-vat][data-variant-without-vat]').forEach(card => {
      const withVat = card.getAttribute('data-variant-with-vat');
      const withoutVat = card.getAttribute('data-variant-without-vat');
      if (withVat && withoutVat) {
        variantMap.set(withVat, withoutVat);
      }
    });
    
    // Подготавливаем обновления для корзины
    const updates = {};
    const itemsToAdd = [];
    
    cart.items.forEach(item => {
      const variantIdStr = item.variant_id.toString();
      const vatExemptVariant = variantMap.get(variantIdStr);
      
      if (vatExemptVariant && vatExemptVariant !== variantIdStr) {
        // Этот товар нужно заменить
        updates[item.variant_id] = 0; // Удаляем вариант с VAT
        itemsToAdd.push({
          id: parseInt(vatExemptVariant),
          quantity: item.quantity
        }); // Добавим вариант без VAT
      }
    });
    
    // Удаляем старые варианты с VAT
    if (Object.keys(updates).length > 0) {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
      
      // Добавляем новые варианты без VAT
      for (const item of itemsToAdd) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(item)
        });
      }
    }
    
  } catch (error) {
    console.error('Error replacing cart items with VAT exempt variants:', error);
  }
}

function updateVatFormStatus() {
  // Убираем проверку страницы - форма должна работать везде
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      attributes: {
        vat_form_completed: 'true'
      }
    })
  })
  .then(response => response.json())
  .then(async data => {
    console.log('VAT form status updated:', data);
    
    // Обновляем цены на всех карточках
    updateVatPrices(true);
    
    // Обновляем атрибуты на карточках
    document.querySelectorAll('.custom-product-upgrade-card').forEach(card => {
      card.setAttribute('data-vat-completed', 'true');
    });
    document.querySelectorAll('.custom-product-offer-card').forEach(card => {
      card.setAttribute('data-vat-completed', 'true');
    });
    
    // ВАЖНО: Заменяем товары в корзине на варианты без VAT
    await replaceCartItemsWithVatExempt();
    
    // Обновляем сводку корзины
    if (typeof window.updateCustomCartSummary === 'function') {
      window.updateCustomCartSummary();
    }
    
    // Перезагружаем страницу только на recommendation-center
    if (window.location.pathname.includes('/pages/recommendation-center')) {
      location.reload();
    }
  })
  .catch(error => console.error('Error updating cart:', error));
}

 $(document).on('submit', '#VatReliefDeclaration', function(event) {
  event.preventDefault();
  var formData = {};
  $(this).serializeArray().forEach(function(field) {
    formData[field.name] = field.value;
  });

  var data = JSON.stringify(formData, null, 2);
  localStorage.setItem("VatReliefDeclaration", data);

  updateVatFormStatus()

  $('.vat-popup').hide();
  $('.vat-modal').hide();
  $('.success-msg').removeClass('hide');
  $('.vat-msg').addClass('hide');
  $('.pdp-button-main').removeClass("disabled");
});

function updateVatPrices(withoutVat) {
  $('.custom-product-offer-card').each(function() {
    const $card = $(this);
    const $withVat = $card.find('[data-price-type="with-vat"]');
    const $withoutVat = $card.find('[data-price-type="without-vat"]');

    if (withoutVat) {
      $withVat.removeClass('price-active').addClass('price-inactive');
      $withoutVat.removeClass('price-inactive').addClass('price-active');

      const variantWithoutVatId = $card.data('variant-without-vat');
      $card.find('.custom-add-to-cart-btn, .quantity-add-to-cart-btn')
           .attr('data-variant-id', variantWithoutVatId)
           .data('variant-id', variantWithoutVatId);
    } else {
      $withoutVat.removeClass('price-active').addClass('price-inactive');
      $withVat.removeClass('price-inactive').addClass('price-active');

      const variantWithVatId = $card.data('variant-with-vat');
      $card.find('.custom-add-to-cart-btn, .quantity-add-to-cart-btn')
           .attr('data-variant-id', variantWithVatId)
           .data('variant-id', variantWithVatId);
    }
  });
}

$('[href="/cart"], .product-cart_button').on('click', function(){
 setTimeout(function() {
  var VatReliefDeclaration = localStorage.getItem("VatReliefDeclaration");
  if (VatReliefDeclaration) {
    var updateValues = JSON.parse(VatReliefDeclaration);
    fetch('/cart/update.js', {
        method: "POST",
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json;'
        },
        body: JSON.stringify({
            attributes: {
                'First Name': updateValues["First Name"],
                'Last Name': updateValues["Last Name"],
                'Email': updateValues["Email"],
                'Condition': updateValues["Condition"],
                'Agree VAT': updateValues["Agree"]
            }
        })
    });
    $('.cart-error').html('');
    $('.btn-checkout').attr("disabled", false);
  }else{
   var option = $('[data-item-option]').text();
  if (option.includes('VAT Exempt')) {
    $('.cart-error').html('<p>Note: You will need to complete a VAT Relief Declaration or switch it to include VAT if a mistake was made.</p>');
    $('.btn-checkout').attr("disabled", true);
  }else{
    $('.cart-error').html('');
    $('.btn-checkout').attr("disabled", false);
  }
}
  }, 1800);
});

    function updateBundleItems(selectedVAT) {
    // For non-UK markets, assume "Including VAT" if no VAT selection is found
    if (!window.isUKMarket && !selectedVAT) {
      selectedVAT = 'Including VAT';
    }
    
    if (selectedVAT) {
      $(`.vat_change-js[value="${selectedVAT}"]`).trigger('click');
    }
    
    var VatReliefDeclaration = localStorage.getItem("VatReliefDeclaration");
    if(selectedVAT ==='VAT Exempt'){
      $('.basket-vat-declare').show();
        if(!VatReliefDeclaration){
        $('.pdp-button-main').addClass("disabled");
        }else{
        $('.pdp-button-main').removeClass("disabled");
        }
    }else{
        if(VatReliefDeclaration){
        $('.pdp-button-main').addClass("disabled");
        }else{
        $('.pdp-button-main').removeClass("disabled");
        }
      $('.basket-vat-declare').hide();
    }

$('input[name="bundleGroup"]').on('change', function() {
  const bundleId = $(this).data('id');
  const bundleProduct = $(`.data-bundle-product[data-bundleid="${bundleId}"]`);
  if ($(this).is(':checked')) {
      bundleProduct.addClass('active');
  } else {
      bundleProduct.removeClass('active');
  }
});

                                                                                                                                                                                                                                                                                                                                                                                                                
$('input[name="bundleGroup"]').each(function() {
  const bundleId = $(this).data('id');
  const bundleProduct = $(`.data-bundle-product[data-bundleid="${bundleId}"]`);
 
  if ($(this).is(':checked')) {
      bundleProduct.addClass('active');
  } else {
      bundleProduct.removeClass('active');
  }
});

        $('.bundle-cart-item').each(function() {
            var $bundleItem = $(this);
            var $select = $bundleItem.find('select.fbt-product-select');

            var optionFound = false;
            $select.find('option').each(function() {
                var $option = $(this);

                if ($option.data('title').indexOf(selectedVAT) !== -1) {
                    $select.val($option.val());

                    var newPrice1 = $option.data('price1');
                    var newPrice = $option.data('price');
                    $bundleItem.find('.bundle-price .price, .bundle-price .price-sale').html(newPrice1);

                    var newId = $option.val();
                    $bundleItem.find('input[name="bundleGroup"]').attr('data-id', newId).attr('data-price', newPrice);

                    var newTitle = $option.data('title');
                    $bundleItem.find('.bundle-item-option').text(newTitle);

                    optionFound = true;
                    return false;
                }
            });

            if (!optionFound) {
                // No matching option found
            }
        });

        var totalPrice = 0;
        $('input[name="bundleGroup"]:checked').each(function() {
            var price = parseFloat($(this).attr('data-price'));
            totalPrice += price;
        });

        $('[data-bundle-total]').html(`${Shopify.formatMoney(totalPrice)}`);
    }

    // $('.fbt_vat_change-js').on('change', function() {
    //     var selectedVAT = $(this).val();
    //     console.log('Selected VAT:', selectedVAT);
    //     updateBundleItems(selectedVAT);
    // });

    // Initial setup on page load
    var initialVAT = $('.fbt_vat_change-js:checked').val();
   // For non-UK markets, assume "Including VAT" since VAT selectors are hidden
   if (!window.isUKMarket && !initialVAT) {
     initialVAT = 'Including VAT';
   }
    updateBundleItems(initialVAT);

   var initialVAT = $('.vat_change-js:checked').val();
   // For non-UK markets, assume "Including VAT" since VAT selectors are hidden
   if (!window.isUKMarket && !initialVAT) {
     initialVAT = 'Including VAT';
   }
    updateBundleItems(initialVAT);


 $('.fbt_vat_change-js').on('change', function() {
        var selectedVAT = $(this).val();
        
        // Check if we're in a non-UK market and force "Including VAT" if needed
        if (!window.isUKMarket && selectedVAT === 'VAT Exempt') {
          $('.fbt_vat_change-js[value="Including VAT"]').prop('checked', true).trigger('change');
          return;
        }
        
        updateBundleItems(selectedVAT);
  });

   $('.vat_change-js').on('change', function() {
        var selectedVAT = $(this).val();
        updateBundleItems(selectedVAT);
  });


  
  $(document).on('change', '.select-option select', function() {
    var varient_Value = $('[name="id"] option:selected').text();
    const varient_array = varient_Value.split("/ ");
    var variant_one = varient_array[0].trim();
    var variant_two = varient_array[1].trim();
    var variant_three = varient_array[2];

console.log(varient_array);
    let newvalue='';
  var selected_color_variant_option = $(this).find('option:selected').text();
  var option_size =$('.vat-content-price').data('option-size') * 1;
    if (option_size > 1) {
      $(".bold-price").hide();
        $('[name="options[VAT]"] option').each(function () {
            var selected_VAT_Value= $(this).val();
              if(variant_three != undefined){
               var variant_lastest =  variant_three.trim();
                 newvalue = selected_VAT_Value+' / '+variant_two+' / '+variant_lastest;
                 $(".bold-price").each(function () {
                  if ($(this).data("option").includes(newvalue)) {
                  $(this).show();
                  var vat_selected = $('#Option1').val();
                   if(vat_selected === selected_VAT_Value){
                      var new_price=$(this).text().trim();
                       $('.price').html(new_price);
                    }
                  }
                 });
              }
             
             var newvalue = selected_color_variant_option +' / '+ selected_VAT_Value;
              console.log('123',newvalue);
                  $(".bold-price").each(function () {
                  if ($(this).data("option").includes(newvalue)) {
                  $(this).show();
                  var vat_selected = $('#Option1').val();
                   if(vat_selected === selected_VAT_Value){
                      var new_price=$(this).text().trim();
                       $('.price').html(new_price);
                    }
                  }
                 });
                });
             }else{
              $(".bold-price").show();
            }
    
    var VatReliefDeclaration = localStorage.getItem("VatReliefDeclaration");
    if(!VatReliefDeclaration){
    var option_vat = $('.option-vat:checked').val();
    if(option_vat == 'VAT Exempt'){
        setTimeout(function() {
       $('.pdp-button-main').addClass("disabled");
      }, 1000);
    }
    }

var selectedValue = $('[name="FBT VAT"]:checked').val();
var selectedValue12 = $('[name="FBT VAT"]:checked').val() + ' \/ ';
    console.log("ssssss", selectedValue);
var myid = $('[name="id"]').val();
var mytitle12 = $(`[name="id"] option[value="${myid}"]`).text();
if(selectedValue != mytitle12){
var mytitle = mytitle12.replace(selectedValue12, '').trim();
console.log(mytitle);
  $(".bold-price").each(function () {
  if ($(this).data("option").includes(mytitle)) {
  $(this).show();
  }else{
  $(this).hide();
 }
  });
}
  });

  $(document).on('change', '.swatch-option .swt-type-button', function() {
  var selected_color_variant_option = $(this).val();
  var option_size =$('.vat-content-price').data('option-size') * 1;
    if (option_size > 1) {
      $(".bold-price").hide();
        $('[name="options[VAT]"] option').each(function () {
            var selected_VAT_Value= $(this).val();
              var newvalue = selected_color_variant_option +' / '+ selected_VAT_Value;
              console.log('1234567',newvalue);
                  $(".bold-price").each(function () {
                  if ($(this).data("option").includes(newvalue)) {
                  $(this).show();
                  var vat_selected = $('#Option1').val();
                   if(vat_selected === selected_VAT_Value){
                      var new_price=$(this).text().trim();
                       $('.price').html(new_price);
                    }
                  }
                 });
                });
             }else{
              $(".bold-price").show();
            }
    
    var VatReliefDeclaration = localStorage.getItem("VatReliefDeclaration");
    if(!VatReliefDeclaration){
    var option_vat = $('.option-vat:checked').val();
    if(option_vat == 'VAT Exempt'){
        setTimeout(function() {
       $('.pdp-button-main').addClass("disabled");
      }, 1000);
    }
    }



var selectedValue = $('[name="FBT VAT"]:checked').val();
var selectedValue12 = $('[name="FBT VAT"]:checked').val() + ' \/ ';
    console.log("ssssss", selectedValue);
var myid = $('[name="id"]').val();
var mytitle12 = $(`[name="id"] option[value="${myid}"]`).text();
if(selectedValue != mytitle12){
var mytitle = mytitle12.replace(selectedValue12, '').trim();
console.log(mytitle);
  $(".bold-price").each(function () {
  if ($(this).data("option").includes(mytitle)) {
  $(this).show();
  }else{
  $(this).hide();
 }
  });
}


  });
});




$(document).ready(function() {
// New code



function changeProOptionFBT(item) {
    var item_parent = $(item).parents('.item-main-list');
    var main_select = $(item_parent).find('.select-tab-fbt');
    var valuesArray = [];
    var pro_select_options = $(item_parent).find('.pro-select_options');
    var color_input = $(item_parent).find('.swt-type-color:checked');
    
    if(color_input.length){
        var color_value = $(color_input).val();
        var color_index = $(color_input).attr('data-index');
        console.log(color_input);
        
        // Store the color value in the appropriate index
        if (color_index !== undefined) {
            valuesArray[color_index] = color_value;
        }
    }
    
    // Iterate through the select options and store their values in the same index
    pro_select_options.each(function(index) {
        var optionValue = $(this).val();
        var select_index = $(this).attr('data-index');
        if (select_index !== undefined) {
            valuesArray[select_index] = optionValue;  
        }
    });
    
    // Join the values that are not undefined to avoid empty entries in the final output
    var joinedValues = valuesArray.filter(value => value !== undefined).join(' / '); 
    
    // If no options are selected (empty joinedValues), use the first available variant
    if (!joinedValues && main_select.length > 0) {
        var $firstOption = main_select.find('option:not([disabled]):first');
        if ($firstOption.length > 0) {
            var price_amount = $firstOption.attr('data-price');
            var price_formatted = $firstOption.attr('data-price1');
            var vid = $firstOption.attr('value');
            
            if (price_amount && price_formatted) {
                var vatExemptText = window.isUKMarket ? '' : '<span class="pro-price-vat-exempt"> ex. VAT</span>';
                $(item_parent).find('.pro-price').html(`${price_formatted}${vatExemptText}`);
            }
            if (vid) {
                main_select.val(vid);
                var changeEvent = new Event('change');
                main_select[0].dispatchEvent(changeEvent);
            }
            return;
        }
    }
    
    // Original logic for when options are selected
    var vid = main_select.find(`option[data-title="${joinedValues}"]`).attr('value');
    var price_amount = main_select.find(`option[data-title="${joinedValues}"]`).attr('data-price');
    
    if (price_amount) {
        var vatExemptText = !window.isUKMarket ? '<span class="pro-price-vat-exempt"> ex. VAT</span>' : '';
        $(item_parent).find('.pro-price').html(`${Shopify.formatMoney(price_amount)}${vatExemptText}`);
    }
    if (vid) {
        main_select.val(vid);
        var changeEvent = new Event('change');
        main_select[0].dispatchEvent(changeEvent);
    }
}


$('.pro-select_options,.color-tab-fbt .swt-type-color').change(function(){
    changeProOptionFBT($(this));
    priceChangeFBT();
});
$('.fbt_vat_input-js').change(function(){
  var selectedValue = $('.fbt_vat_input-js:checked').val();
  
          // Check if we're in a non-UK market and force "Including VAT" if needed
        if (!window.isUKMarket && selectedValue === 'VAT Exempt') {
          $('.fbt_vat_input-js[value="Including VAT"]').prop('checked', true).trigger('change');
          return;
        }
  $(`.vat_change-js[value="${selectedValue}"]`).trigger('click');

  $('.addItemFbt').each(function() { 
    changeProOptionFBT($(this));
  });
  priceChangeFBT();
});
 
$('.addItemFbt').change(function(){
  priceChangeFBT();
});
function priceChangeFBT() {
  let checkedCount = 0;
  $('.addItemFbt').each(function() {
      if ($(this).is(':checked')) {
          checkedCount++;
      }
  });
  if (checkedCount > 0) {
    $('.tab-add-to-cart').prop('disabled', false);
} else {
  $('.tab-add-to-cart').prop('disabled', true);
}
  var includingVATPrice = 0;
  var vatExemptPrice = 0;
  var vat = '';
  $('.addBundleProduts').html('');
  $('.addItemFbt').each(function() {

    if ($(this).is(':checked')) {
      var item_parent = $(this).parents('.item-main-list');
      var select = $(this).siblings('.select-tab-fbt');
      vat = $(item_parent).find('pro-select_options').val();
      
      // For non-UK markets, assume "Including VAT" if no VAT selection is found
      if (!window.isUKMarket && !vat) {
        vat = 'Including VAT';
      }
      var value = $(select).val();
      $('.addBundleProduts').append(`<input type="checkbox" name="bundleGroup" checked="checked" id="bundleItem_${value}" data-id="${value}" value="${value}" >`);
      var data_title = $(select).find(`option[value="${value}"]`).attr('data-title');
      var data_price = $(select).find(`option[value="${value}"]`).attr('data-price');

      
      if(vat === 'VAT Exempt'){
        vatExemptPrice += parseFloat(data_price);
      }else{
        var new_data_title = data_title.replace(/Including VAT/g, 'VAT Exempt');
        var new_data_price = $(select).find(`option[data-title="${new_data_title}"]`).attr('data-price');
        vatExemptPrice += parseFloat(new_data_price);
      }
      if(vat === 'Including VAT'){
        includingVATPrice += parseFloat(data_price);
      }else{
        var new_data_title = data_title.replace(/VAT Exempt/g,'Including VAT');
        var new_data_price = $(select).find(`option[data-title="${new_data_title}"]`).attr('data-price');
        includingVATPrice += parseFloat(new_data_price);
      }
      
      }
  });
    $('.tab_price-including-vat').html(`${Shopify.formatMoney(includingVATPrice)}`);
    $('.tab_price-vat-exempt').html(`${Shopify.formatMoney(vatExemptPrice)}`);
    var selectedValue = $('.fbt_vat_input-js:checked').val();
    
    // For non-UK markets, assume "Including VAT" if no VAT selection is found
    if (!window.isUKMarket && !selectedValue) {
      selectedValue = 'Including VAT';
    }
    
    if(selectedValue === 'Including VAT'){
      $('.tab-fbt-total-price').html(`${Shopify.formatMoney(includingVATPrice)}`);
    }else{
      $('.tab-fbt-total-price').html(`${Shopify.formatMoney(vatExemptPrice)}`);
    }
}



function checkFirstInput() {
  $('.color-tab-fbt').each(function() {
    $(this).find('.swt-color:first').trigger('click');
  });
}

    setTimeout(function() {
    checkFirstInput();

var selectedValue = $('[name="FBT VAT"]:checked').val();
var selectedValue12 = selectedValue ? selectedValue + ' \/ ' : '';
var myid = $('[name="id"]').val();
var mytitle12 = $(`[name="id"] option[value="${myid}"]`).text();

// For non-UK markets, assume "Including VAT" since VAT selectors are hidden
if (!window.isUKMarket && !selectedValue) {
  selectedValue = 'Including VAT';
  selectedValue12 = selectedValue + ' \/ ';
}

if(selectedValue && selectedValue != mytitle12){
var mytitle = mytitle12.replace(selectedValue12, '').trim();
  $(".bold-price").each(function () {
  if ($(this).data("option").includes(mytitle)) {
  $(this).show();
  }
  });
}

    var current_screen_size = $(window).width();
    if(selectedValue === 'Including VAT'){
      if(current_screen_size >= 768) {
        setTimeout(function() {
          $('#tab_fbt_radio_including-vat').trigger('click');
        }, 200);
      }else{
        setTimeout(function() {
          $('[for="mob_tab_fbt_radio_including-vat"]').trigger('click');
        }, 200);
      }
    }else{
      if(current_screen_size >= 768) {
        setTimeout(function() {
          $('#tab_fbt_radio_vat-exempt').trigger('click');
        }, 200);
      }else{
        setTimeout(function() {
          $('[for="mob_tab_fbt_radio_vat-exempt"]').trigger('click');
        }, 200);
      }
    }
    
    // Handle FBT VAT initialization
    handleFBTVATInitialization();
    
    // Handle Product Bundle VAT initialization
    handleProductBundleVATInitialization();
    
    // Single optimized check for non-UK markets
    if (!window.isUKMarket && !window.nonUKVATOverrideCompleted) {
      // Quick check to ensure VAT selection is correct
      const mainVariantSelect = document.querySelector('select[name="id"]');
      if (mainVariantSelect) {
        const currentVariant = mainVariantSelect.options[mainVariantSelect.selectedIndex];
        if (currentVariant && currentVariant.textContent.includes('VAT Exempt')) {
          forceIncludingVATSelection();
          window.nonUKVATOverrideCompleted = true;
        }
      }
      
      // Periodic check for non-UK markets to ensure VAT selection stays correct
      setInterval(function() {
        const mainVariantSelect = document.querySelector('select[name="id"]');
        if (mainVariantSelect) {
          const currentVariant = mainVariantSelect.options[mainVariantSelect.selectedIndex];
          if (currentVariant && currentVariant.textContent.includes('VAT Exempt')) {
            forceIncludingVATSelection();
          }
        }
        
        // Also check FBT VAT selection periodically
        handleFBTVATInitialization();
        
        // Also check Product Bundle VAT selection periodically
        handleProductBundleVATInitialization();
      }, 5000); // Increased from 3 seconds to 5 seconds to reduce frequency
    }
  }, 1000); // Reduced from 2000ms to 1000ms
});

// Function to handle FBT VAT initialization and URL override
// This function ensures FBT (Frequently Bought Together) VAT selectors behave consistently
// with the main product VAT selectors:
// - UK markets: Show VAT selectors (no auto-selection)
// - Non-UK markets: Auto-select "Including VAT" and hide VAT selectors
// - URL variant override: Force "Including VAT" for non-UK markets even if URL contains VAT Exempt variant
function handleFBTVATInitialization() {
  // Check if FBT VAT inputs exist
  const fbtVatInputs = document.querySelectorAll('.fbt_vat_input-js');
  if (fbtVatInputs.length === 0) {
    return;
  }
  
  // For non-UK markets, handle URL variant override
  if (!window.isUKMarket && window.location.search.includes('variant=')) {
    // Check if current URL variant is VAT Exempt
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
    
    if (variantId) {
      // Find the variant option that matches this ID
      const variantSelect = document.querySelector('select[name="id"]');
      if (variantSelect) {
        const variantOption = variantSelect.querySelector(`option[value="${variantId}"]`);
        if (variantOption && variantOption.textContent.includes('VAT Exempt')) {
          // Force "Including VAT" selection for FBT
          const includingVatInput = document.querySelector('.fbt_vat_input-js[value="Including VAT"]');
          if (includingVatInput) {
            includingVatInput.checked = true;
            includingVatInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    }
  }
  
  // For non-UK markets only, auto-select "Including VAT" if not already selected
  if (!window.isUKMarket) {
    const includingVatInput = document.querySelector('.fbt_vat_input-js[value="Including VAT"]');
    const currentSelection = document.querySelector('.fbt_vat_input-js:checked');
    
    if (includingVatInput && (!currentSelection || currentSelection.value !== 'Including VAT')) {
      includingVatInput.checked = true;
      includingVatInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}
         
// Function to handle Product Bundle VAT initialization and URL override
// This function ensures Product Bundle VAT selectors behave consistently
// with the main product VAT selectors:
// - UK markets: Show VAT selectors (no auto-selection)
// - Non-UK markets: Auto-select "Including VAT" and hide VAT selectors
// - URL variant override: Force "Including VAT" for non-UK markets even if URL contains VAT Exempt variant
function handleProductBundleVATInitialization() {
  // Check if Product Bundle VAT inputs exist
  const bundleVatInputs = document.querySelectorAll('.fbt_vat_change-js');
  if (bundleVatInputs.length === 0) {
    return;
  }
  
  // For non-UK markets, handle URL variant override
  if (!window.isUKMarket && window.location.search.includes('variant=')) {
    // Check if current URL variant is VAT Exempt
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
    
    if (variantId) {
      // Find the variant option that matches this ID
      const variantSelect = document.querySelector('select[name="id"]');
      if (variantSelect) {
        const variantOption = variantSelect.querySelector(`option[value="${variantId}"]`);
        if (variantOption && variantOption.textContent.includes('VAT Exempt')) {
          // Force "Including VAT" selection for Product Bundle
          const includingVatInput = document.querySelector('.fbt_vat_change-js[value="Including VAT"]');
          if (includingVatInput) {
            includingVatInput.checked = true;
            includingVatInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    }
  }
  
  // For non-UK markets only, auto-select "Including VAT" if not already selected
  if (!window.isUKMarket) {
    const includingVatInput = document.querySelector('.fbt_vat_change-js[value="Including VAT"]');
    const currentSelection = document.querySelector('.fbt_vat_change-js:checked');
    
    if (includingVatInput && (!currentSelection || currentSelection.value !== 'Including VAT')) {
      includingVatInput.checked = true;
      includingVatInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}
        
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".accordion-header").forEach(header => {
    header.addEventListener("click", function () {

      let content = this.nextElementSibling;

      content.style.display =
        content.style.display === "block" ? "none" : "block";

      document.querySelectorAll(".accordion-header").forEach(h => h.classList.remove("active"));
      this.classList.toggle("active");
    });
  });
});

function updateProductTags() {

  const activeTags = [];

  document.querySelectorAll('.quick-filter-btn.active').forEach(button => {
    activeTags.push(
      button.textContent.replace('×', '').trim()
    );
  });

  document.querySelectorAll('.label_ui-tag').forEach(tag => {

    const tagText = tag.textContent.trim();

    tag.style.display = activeTags.includes(tagText)
      ? 'inline-flex'
      : 'none';

  });

}
document.addEventListener('DOMContentLoaded', updateProductTags);
document.addEventListener('click', async function(e) {
  const button = e.target.closest('.quick-filter-btn');

  if (!button) return;

  e.preventDefault();

  const url = button.getAttribute('href');

  try {

    // Loading class optional
    document.body.classList.add('loading');
    
    const response = await fetch(url);
    const html = await response.text();

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    // Replace Products
    const newProducts = doc.querySelector('[data-content-dynamic]');
    const currentProducts = document.querySelector('[data-content-dynamic]');

    currentProducts.innerHTML = newProducts.innerHTML;

    // Replace Filters
    const newFilters = doc.querySelector('.custom-quick-filters');
    const currentFilters = document.querySelector('.custom-quick-filters');

    currentFilters.innerHTML = newFilters.innerHTML;

    // Update URL
    window.history.pushState({}, '', url);
    updateProductTags();
    document.body.classList.remove('loading');

  } catch(error) {

    console.error(error);
    document.body.classList.remove('loading');

  }

});